// extracted by mini-css-extract-plugin
export default {"footer__container":"Footer_footer__container__UCMnh"};